import * as React from 'react'

export interface SvgIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  decorative?: boolean
}

const createIcon = (
  displayName: string,
  src: string,
  defaultAlt: string
): React.ForwardRefExoticComponent<SvgIconProps & React.RefAttributes<HTMLImageElement>> => {
  const IconComponent = React.forwardRef<HTMLImageElement, SvgIconProps>(
    ({ decorative = true, alt, ...rest }, ref) => {
      const computedAlt = decorative ? '' : (alt ?? defaultAlt)
      const ariaHidden = decorative && !alt ? true : undefined

      return <img ref={ref} src={src} alt={computedAlt} aria-hidden={ariaHidden} {...rest} />
    }
  )

  IconComponent.displayName = displayName

  return IconComponent
}

const iconPath = (name: string) => `/icons/${name}.svg`

export const ARCSIcon = createIcon('ARCSIcon', iconPath('ARCSIcon'), 'ARCS')
export const AlertIcon = createIcon('AlertIcon', iconPath('AlertIcon'), 'Alert')
export const BackIcon = createIcon('BackIcon', iconPath('BackIcon'), 'Back')
export const ChevronRightIcon = createIcon(
  'ChevronRightIcon',
  iconPath('ChevronRightIcon'),
  'Chevron right'
)
export const CloseIcon = createIcon('CloseIcon', iconPath('CloseIcon'), 'Close')
export const ContactIcon = createIcon('ContactIcon', iconPath('ContactIcon'), 'Contact')
export const CopyIcon = createIcon('CopyIcon', iconPath('CopyIcon'), 'Copy')
export const DotsIcon = createIcon('DotsIcon', iconPath('DotsIcon'), 'Dots')
export const DownloadIcon = createIcon('DownloadIcon', iconPath('DownloadIcon'), 'Download')
export const EmptyIcon = createIcon('EmptyIcon', iconPath('EmptyIcon'), 'Empty')
export const ExpandIcon = createIcon('ExpandIcon', iconPath('ExpandIcon'), 'Expand')
export const FeatureIcon = createIcon('FeatureIcon', iconPath('FeatureIcon'), 'Feature')
export const HistoryIcon = createIcon('HistoryIcon', iconPath('HistoryIcon'), 'History')
export const HomeIcon = createIcon('HomeIcon', iconPath('HomeIcon'), 'Home')
export const LogoutIcon = createIcon('LogoutIcon', iconPath('LogoutIcon'), 'Logout')
export const MailIcon = createIcon('MailIcon', iconPath('MailIcon'), 'Mail')
export const NotificationIcon = createIcon(
  'NotificationIcon',
  iconPath('NotificationIcon'),
  'Notification'
)
export const QRIcon = createIcon('QRIcon', iconPath('QRIcon'), 'QR')
export const QuestionIcon = createIcon('QuestionIcon', iconPath('QuestionIcon'), 'Question')
export const ScanIcon = createIcon('ScanIcon', iconPath('ScanIcon'), 'Scan')
export const SendIcon = createIcon('SendIcon', iconPath('SendIcon'), 'Send')
export const SettingsIcon = createIcon('SettingsIcon', iconPath('SettingsIcon'), 'Settings')
export const GearIcon = createIcon('GearIcon', iconPath('GearIcon'), 'Gear')
export const ShareIcon = createIcon('ShareIcon', iconPath('ShareIcon'), 'Share')
export const StoreIcon = createIcon('StoreIcon', iconPath('StoreIcon'), 'Store')
export const VerticalDotsIcon = createIcon(
  'VerticalDotsIcon',
  iconPath('VerticalDotsIcon'),
  'Vertical dots'
)

export type SvgIconComponent = typeof BackIcon
